import { loadVehicles, loadVehiclesSuccess, reloadVehicles } from './vehicles.actions';
import { createFeature, createReducer, on } from '@ngrx/store';
import { Vehicle } from '@agilox/common';

export interface VehiclesState {
	vehicles: Vehicle[];
}

const initialState: VehiclesState = {
	vehicles: [],
};

const reducer = createReducer(
	initialState,
	on(loadVehicles, (state) => ({ ...state })),
	on(reloadVehicles, (state) => ({ ...state })),
	on(loadVehiclesSuccess, (state, action) => ({ ...state, vehicles: action.value }))
);

export const vehiclesStateFeature = createFeature({
	name: 'vehiclesState',
	reducer,
});
